'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = error;

var _updeep = require('updeep');

var _updeep2 = _interopRequireDefault(_updeep);

var _update2 = require('./_update');

var _update3 = _interopRequireDefault(_update2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function error(root, id, error) {
    return (0, _updeep2.default)({
        resources: (0, _defineProperty3.default)({}, id, function (entry) {
            return (0, _update3.default)(entry, {
                error: error,
                state: _constants.ERROR
            });
        })
    }, root || {});
}